import { css } from '@linaria/core';

export const item = css`
  display: block;
`;

export const questionButton = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--cxy-spacing-5) var(--cxy-spacing-4);
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: var(--cxy-fontWeight-bold);
  text-align: left;
`;

export const questionText = css`
  color: var(--cxy-color-midnight-blue-700);
  flex: 1;
  font-size: var(--cxy-fontSize-m);
  margin-right: var(--cxy-spacing-2);
`;

export const chevronSvg = css`
  flex-shrink: 0;
  transition: transform 0.2s ease-in-out;

  &[data-open='true'] {
    transform: rotate(180deg);
  }
`;

export const answerContent = css`
  transition: opacity 300ms ease;
  opacity: 0;
  padding: 0 var(--cxy-spacing-4) var(--cxy-spacing-5);
  color: var(--cxy-color-midnight-blue-400);
  font-size: var(--cxy-fontSize-s);

  & * {
    font-size: inherit;
  }

  &[data-enter] {
    opacity: 1;
  }
`;
